import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Award, Crown } from 'lucide-react';

const STYLE = {
  'Ambassador AgriNexus': { I: Award, cls: 'border-chartreuse/50 bg-chartreuse/10 text-foreground', short: 'Ambassador' },
  'Partner della community': { I: Crown, cls: 'border-terracotta/50 bg-terracotta/10 text-foreground', short: 'Partner' },
};

// Badge pubblici del Codice Amico (solo Ambassador e Partner) accanto al nome del proprietario.
export default function OwnerBadges({ ownerId }) {
  const [badges, setBadges] = useState([]);
  useEffect(() => {
    if (!ownerId) return;
    api.get(`/users/${ownerId}`).then(r => setBadges((r.data?.referral_badges || []).filter(b => STYLE[b]))).catch(() => {});
  }, [ownerId]);
  return badges.map(b => {
    const { I, cls, short } = STYLE[b];
    return (
      <span key={b} data-testid={`owner-badge-${short.toLowerCase()}`}
            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full border ${cls}`}>
        <I size={11}/> {short}
      </span>
    );
  });
}
